<template>
  <div class="animated fadeIn">
    <div class="mb-10 mt-20">
      <div class="row">
        <div class="col-6">
          <a @click="openPage('/allForm/addGrabAndGo')" class="btn-grey"><i class="fas fa-arrow-circle-left mr-5"></i>Back</a>
        </div>
      </div>
    </div>
    <div class="box">
      <div class="p-15">
        <div>Add New Product</div>
        <hr class="short-line left mb-20">
        <form @submit.prevent="addProduct('validateAddProduct')" data-vv-scope="validateAddProduct">
          <div class="row mb-10">
            <div class="col-md-6">
              <div class="mb-10">
                <b-form-input class="border-bottom" v-model="addNewProduct.name" placeholder="Product Name" v-validate="'required'" name="product_name" type="text"></b-form-input>
                <span class="error">{{ errors.first('validateAddProduct.product_name') }}</span>
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-10">
                <b-form-input class="border-bottom" v-model="addNewProduct.price" placeholder="Product Price" v-validate="'required'" name="product_price" type="text"></b-form-input>
                <span class="error">{{ errors.first('validateAddProduct.product_price') }}</span>
              </div>
            </div>
            <!-- <b-row class="mb-20">
              <b-col sm="3">
                <label>Cancel Category</label>
              </b-col>
              <b-col sm="9">
                <b-form-select class="border-bottom" name="product_type" v-validate="'required'" v-model="addNewProduct.product_type_id">
                  <option v-for="item in product_type" :key="item.id" :value="item.id">{{item.name}}</option>
                </b-form-select>
              </b-col>
            </b-row> -->
          </div>
          <div class="text-right">
            <button type="submit" class="btn-primary">Save</button>
          </div>
        </form>
      </div>
      <hr>
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-sm-7">
          </div>
          <div class="col-sm-5 text-right">
            <div class="search-header">
              <div class="custom-search-container">
                <div class="input-group custom-search">
                  <input type="text" @keyup.enter="enterClicked(searchData)" v-model="searchData" class="form-control" placeholder="Search">
                  <span class="icon-magnifier icon-input-custom"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr class="mb-0">
      <div class="p-15 pt-0">
        <b-table @sort-changed="sortingChanged" :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="fields" :current-page="currentPage">
<!--          <template slot="actions" slot-scope="data">-->
          <template v-slot:cell(actions)="data">
            <b-button size="sm" @click="editData('/allForm/grabAndGoProduct/edit?id=' + data.item.id)" class="btn-table primary mr-1">
              <i class="far fa-edit"></i> Edit
            </b-button>
            <b-button size="sm" v-on:click="deleteData(data.item.id)" class="btn-table danger">
              <i class="fas fa-times"></i> Delete
            </b-button>
          </template>
        </b-table>
        <app-pagination class="pagination-custom mt-20" :current-page="currentPage"
            :total-pages="totalPage"
            @page-changed="pageOneChanged"
            prev-text="Prev" next-text="Next"/>
      </div>
    </div>
  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'
import Pagination from '@/views/component/pagination'

export default {
  name: 'grabAndGo',
  components: {
    'app-pagination': Pagination
  },
  props: {
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      fields: [
        {
          key: 'name',
          label: 'Name',
          sortable: true
        },
        {
          key: 'price',
          label: 'Price',
          formatter: (value) => {
            return 'IDR ' + Number(value || 0).toLocaleString('id-ID', { maximumFractionDigits: 0 })
          },
          sortable: true
        },
        {
          key: 'actions',
          label: 'Actions',
          sortable: false
        }
      ],
      addNewProduct: {
        name: '',
        price: '',
        product_type_id: 1,
      },
      items: [],
      product_type: [],
      sortType: '',
      sortBy: '',
      searchData: '',
      currentPage: 1,
      paginationLimit: 10,
      totalPage: 0
    }
  },
  computed: {
    name () {
      return this.$route.name
    }
  },
  methods: {
    addProduct (scope) {
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          console.log('All Data', this.addNewProduct)
          axios.post('crm/v1/grab_and_go_product/', this.addNewProduct).then(response => {
            // console.log('test', response)
            this.$toast.success('data saved successfully!', 'Success', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
            this.$router.push('/allForm/addGrabAndGo')
          }).catch(error => {
            console.log('error', error)
            this.$toast.success('cant saved data!', 'Error', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          })
        } else {
          this.$toast.success('please fill in required fields!', 'Error', {
            position: 'topCenter',
            icon: 'icon-envelope',
            progressBarColor: 'rgb(0, 255, 184)',
            theme: 'dark',
            backgroundColor: '#565c70',
            messageColor: '#fff'
          })
        }
      })
    },
    pageOneChanged (pageNum) {
      this.currentPage = pageNum
      this.fetchData()
    },
    sortingChanged (event) {
      // console.log(event.sortDesc)
      // event.sortBy   ==> Field key for sorting by (or null for no sorting)
      // event.sortDesc ==> true if sorting descending, false otherwise
      this.sortBy = event.sortBy
      if (event.sortDesc === false) {
        this.sortType = 'asc'
        // console.log(this.sortType)
      } else {
        this.sortType = 'desc'
        // console.log(this.sortType)
      }
      this.fetchData()
    },
    enterClicked (searchEvent) {
      this.fetchData()
    },
    getBadge (status) {
      return status === 'Active' ? 'success'
        : status === 'Inactive' ? 'danger'
          : status === 'active' ? 'success'
            : status === 'inactive' ? 'danger' : 'primary'
    },
    getRowCount (items) {
      return items.length
    },
    openPage (event) {
      this.$router.push(event)
    },
    editData (event) {
      this.$router.push(event)
    },
    showModal (id) {
      this.$refs[id].show()
    },
    deleteData(event) {
      this.$swal({
        title: 'Are you sure?',
        text: 'You can\'t revert your action',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes Delete it!',
        cancelButtonText: 'No, Keep it!',
        showCloseButton: true,
        showLoaderOnConfirm: false
      }).then((result) => {
        if(result.value) {
          this.$swal('Deleted', 'You successfully deleted this file', 'success')
          axios.defaults.headers.common['X-Access-Token'] = Auth.Session.get().paradigm_token
          axios.delete('crm/v1/grab_and_go_product/'+(event)).then(response => {
            // this.$router.go()
            this.fetchData()
          }).catch(error => {
            console.log('error', error)
          })
        } else {
          this.$swal('Cancelled', 'Your file is still intact', 'info')
        }
      })
    },
    fetchData() {
      axios.defaults.headers.common['X-Access-Token'] = Auth.Session.get().paradigm_token
      axios.get('crm/v1/grab_and_go_product?page=' + this.currentPage + '&limit=' + this.paginationLimit + '&sorting=' + this.sortBy + '&sorting_type=' + this.sortType + '&keyword=' + this.searchData+ '&product_type_id=' + this.$route.query.product_type_id).then(response => {
        this.items = response.data.data.rows
        this.totalPage = response.data.meta.pageCount
        // console.log('test', response.data.data.rows)
      }).catch(error => {
        console.log('error', error)
      })

      axios.get('crm/v1/grab_and_go_product/product/product_type').then(response => {
        this.product_type = response.data.data
      }).catch(error => {
        console.log('error', error)
      })
    }
  },
  created () {
    this.addNewProduct.product_type_id = Number(this.$route.query.product_type_id)
    console.log("ADD NEW PRODUCT: ",this.addNewProduct)
    this.fetchData()
  }
}
</script>

<style>
</style>
